import React from 'react';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import CloudQueueOutlinedIcon from '@mui/icons-material/CloudQueueOutlined';
import SettingsCellOutlinedIcon from '@mui/icons-material/SettingsCellOutlined';
import ApiOutlinedIcon from '@mui/icons-material/ApiOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

const services = [
  { icon: <PhoneIphoneOutlinedIcon />, title: "Mobile App\nDevelopment" },
  { icon: <LanguageOutlinedIcon />, title: "Web & Web App\nDevelopment" },
  { icon: <CloudQueueOutlinedIcon />, title: "Cloud Application\nDevelopment" },
  { icon: <SettingsCellOutlinedIcon />, title: "USSD\nDevelopment" },
  { icon: <ApiOutlinedIcon />, title: "API Development\n& Integrations" },
  { icon: <ShareOutlinedIcon />, title: "Intranet & SharePoint\nSolutions" },
  { icon: <PsychologyOutlinedIcon />, title: "IT\nConsulting" },
  { icon: <ChatBubbleOutlineOutlinedIcon />, title: "WhatsApp Chatbot\nDevelopment" },
];

const ServicesBanner = () => {
  return (
    <div className="services-banner">
      <div className="container services-banner-inner">
        {services.map((service, index) => (
          <div key={index} className="services-banner-item animate-fade-in" style={{ animationDelay: `${0.1 * index}s` }}>
            {service.icon}
            <span style={{ whiteSpace: 'pre-line' }}>{service.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesBanner;
